<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g><g><path d="M.343 0h11" style="fill:none;stroke:#2c59d9;stroke-linecap:round;stroke-width:3.4px" transform="translate(2.157 8)" fill="currentColor"/><path d="M.343 0h11" style="fill:none;stroke:#2c59d9;stroke-linecap:round;stroke-width:3.4px" transform="translate(2.157 2.5)" fill="currentColor"/><path d="M.343 0h11" style="fill:none;stroke:#2c59d9;stroke-linecap:round;stroke-width:3.4px" transform="translate(2.157 13.5)" fill="currentColor"/></g></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-lnb-block',
});
</script>
